import React, {useContext, useEffect, useState} from 'react';
import {Avatar, Chip, CircularProgress, Typography} from "@mui/material";
import {CorporateFareRounded} from "@mui/icons-material";
import {connect, useSelector} from "react-redux";
import {corporateActions} from "../redux/actions/CorporateActions";
import {ErrorContext} from "../../components/GympinPagesProvider";
import {corporatePersonnel_corporateOwnedByUserId} from "../../network/api/corporatePersonnel.api";
import {useNavigate} from "react-router";

const SelectCorproate = (props) => {
    const error = useContext(ErrorContext);
    const navigate = useNavigate();
    const user = useSelector(({auth}) => auth.user);
    const [loading, setLoading] = useState(false);
    const corporateInStore = useSelector(({corporate}) => corporate.corporate);
    const [selectedCorporate, setSelectedCorporate] = useState(corporateInStore);
    const [personCorporates, setPersonCorporates] = useState([]);

    useEffect(() => {
        setSelectedCorporate(corporateInStore);
    }, [corporateInStore]);

    useEffect(() => {
        getUserCorporates();
    }, []);

    function getUserCorporates() {
        if (selectedCorporate) return;
        if (personCorporates.length > 0) return;
        setLoading(true);
        corporatePersonnel_corporateOwnedByUserId({id: user?.Id}).then(result => {
            setLoading(false);
            setPersonCorporates(result.data.Data);
            if (result.data.Data?.length < 1) {
                error.showError({message: "مرکزی برای این کاربر یافت نشد",});
            }
            if (!selectedCorporate && result.data.Data?.[0]?.Corporate) {
                setCorporateForUser(result.data.Data[0].Corporate);
            }
        }).catch(e => {
            setLoading(false);
            try {
                error.showError({message: e.response.data.Message,});
            } catch (f) {
                error.showError({message: "خطای نامشخص در دریافت لیست سازمان‌ها",});
            }
        });
    }

    function setCorporateForUser(corporate) {
        if (!corporate) return;
        setSelectedCorporate(corporate);
        props.SetCorporate(corporate);
    }

    return (
        <>
            {loading && <CircularProgress size={20} color="primary" sx={{ mx: 1 }} />}
            {!loading && selectedCorporate && (
                <Chip
                    onClick={() => navigate("/settings/corporates")}
                    avatar={
                        selectedCorporate?.Logo?.Url ? (
                            <Avatar src={selectedCorporate.Logo.Url} />
                        ) : (
                            <Avatar sx={{ bgcolor: 'primary.main', color: '#fff' }}>
                                <CorporateFareRounded sx={{ fontSize: 16 }} />
                            </Avatar>
                        )
                    }
                    label={
                        <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '0.82rem' }}>
                            {selectedCorporate.Name}
                        </Typography>
                    }
                    sx={{
                        cursor: 'pointer',
                        borderRadius: 3,
                        py: 2,
                        px: 0.5,
                        border: '1px solid',
                        borderColor: 'divider',
                        bgcolor: 'background.paper',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.03)',
                        transition: 'all 0.2s ease',
                        '&:hover': {
                            bgcolor: 'action.hover',
                            borderColor: 'primary.main'
                        }
                    }}
                />
            )}
        </>
    );
};

export default connect(null, corporateActions)(SelectCorproate);
